const openSayhiConfig = () => {
  return `hiyaPro://openSayhiConfig`;
};
const openFacetimeCall = (paarms) => {
  return `hiyaPro://openFacetimeCall?t_mid=${paarms.t_mid}&from=chat`;
};
const openUploadCoverPage = () => {
  return "hiyaPro://openUploadCoverPage";
};
const openMainTabFacetime = () => {
  return "hiyaPro://openMainTab?tab=0&sub_tab=0";
};
const openMainTabChat = () => {
  return "hiyaPro://openMainTab?tab=0&sub_tab=1";
};
const openUploadAlbum = () => {
  return "hiyaPro://openUploadAlbum";
};
const openMessageChat = () => {
  return "hiyaPro://openMainTab?tab=3&sub_tab=0";
};
const openMessageFacetime = () => {
  return "hiyaPro://openMainTab?tab=3&sub_tab=1";
};
const openUploadAvatar = () => {
  return "hiyaPro://openUploadAvatar";
};
const getBeInvitedInfo = () => {
  return "hiyaPro://getBeInvitedInfo?from=push";
};
const showQuickPayAlert = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiyaPro://showQuickPayAlert?${paramsArr.join("&")}`;
};
const startVideoMatch = (params) => {
  return `hiyaPro://startVideoMatch?from=${params.from}`;
};
const facetimeReward = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiyaPro://facetimeReward?${paramsArr.join("&")}`;
};
const OpenFacetimeRewardBoard = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiyaPro://OpenFacetimeRewardBoard?from=web&${paramsArr.join("&")}`;
};
export {
  OpenFacetimeRewardBoard,
  facetimeReward,
  getBeInvitedInfo,
  openFacetimeCall,
  openMainTabChat,
  openMainTabFacetime,
  openMessageChat,
  openMessageFacetime,
  openSayhiConfig,
  openUploadAlbum,
  openUploadAvatar,
  openUploadCoverPage,
  showQuickPayAlert,
  startVideoMatch
};
